// extracted by mini-css-extract-plugin
export var tosLink = "_49-0";